const fillStyle = { fill: '#888' }

const EditModern = ({className}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.65 23.89" className={className}><defs><style></style></defs><g id="a"/><g id="b"><g id="c"><path id="d" style={fillStyle} d="M.03,18.01h-.03L6.59,3.26l4.24,1.9-6.59,14.73h-.03L.16,23.36,.03,18.01Z"/><path id="e" style={fillStyle} d="M9.37,.11l1.94,.87c.63,.28,.92,1.03,.64,1.66l-.82,1.83h0l-4.24-1.9h0l.82-1.83c.28-.63,1.03-.92,1.66-.64Z"/><polygon style={fillStyle} points=".2 23.13 17.65 22.36 17.65 23.89 .2 23.13 .2 23.13"/></g></g></svg>
    )
}

export default EditModern
